import React, { useEffect, useState } from 'react'

import { useHistory } from 'react-router-dom'

import { toast } from 'react-toastify'

import EditAddress from '../../../../../presentation/pages/doctors/profile/editAddress'

import { useMe } from '../../../../../presentation/contexts/me'

import { makeDoctorsEdit } from '../../../../usecases/doctors/remote-doctors-factory'
import { makeUsers } from '../../../../usecases/users/remote-users-factory'

import { HelperViaCep } from '../../../../../presentation/helpers/helper-via-cep'
import { STATES } from '../../../../../presentation/helpers'

const MakeEditAddress = () => {
  document.title = 'BuscarMédicos - Editar endereço'

  const history = useHistory()

  const [errorMessage] = useState<string | null>('')

  const { me } = useMe()

  const [cep, setCep] = useState('')

  const [address, setAddress] = useState({
    city: '',
    neighborhood: '',
    street: '',
    state: '',
    zipcode: '',
    number: '',
    complement: '',
  })

  const [user, setUser] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    document: [
      {
        id: 0,
        url: '',
      },
    ],
  })

  const handleCepSelect = (data: any) => {
    const numericCep = data.replace(/\D/g, '')
    setCep(numericCep)
  }

  useEffect(() => {
    const fetchAddress = async () => {
      if (cep.length >= 8) {
        const response = await HelperViaCep.getAdressByCep(cep)
        setAddress(response as any)
      }
      if (cep.length < 8) {
        setAddress({
          city: '',
          neighborhood: '',
          street: '',
          state: '',
          zipcode: cep,
          number: '',
          complement: '',
        })
      }
    }
    fetchAddress()
  }, [cep])

  useEffect(() => {
    const fetchData = async () => {
      if (!me) {
        return
      }

      try {
        const response = await makeUsers().loadDoctorById(me.id)

        setUser(response)
        setAddress({
          city: response.address.city,
          neighborhood: response.address.neighborhood,
          street: response.address.street,
          state: response.address.state,
          zipcode: response.address.zipcode,
          number: response.address.number,
          complement: response.address.complement,
        })
      } catch (error) {
        toast.error('Erro ao carregar especialidades.')
      }
    }

    fetchData()
  }, [me])

  const dataForm = [
    {
      items: [
        {
          component: 'InputMask',
          mask: 'CEP',
          name: 'zipcode',
          label: 'Informe o CEP',
          title: 'Informe o CEP',
          value: address.zipcode,
          type: 'tel',
          required: true,
          placeholder: 'Digite aqui',
          validations: 'inputRequired',
          onChange: handleCepSelect,
        },
        {
          name: 'street',
          component: 'Input',
          value: address.street,
          placeholder: 'Digite aqui',
          type: 'text',
          title: 'Rua',
          label: 'Rua',
          required: true,
          validations: 'inputRequired',
          style: { marginBottom: '15px' },
        },
        {
          component: 'InputGroup',
          style: { display: 'grid', gridTemplateColumns: '1fr 1fr' },
          inputs: [
            {
              name: 'number',
              component: 'InputMask',
              mask: 'ONLY_NUMBERS',
              value: address.number,
              placeholder: 'Digite aqui',
              type: 'tel',
              title: 'Número',
              label: 'Número',
            },
            {
              name: 'neighborhood',
              component: 'Input',
              value: address.neighborhood,
              placeholder: 'Digite aqui',
              type: 'text',
              title: 'Bairro',
              label: 'Bairro',
              required: true,
              validations: 'inputRequired',
            },
          ],
        },
        {
          component: 'InputGroup',
          style: { display: 'grid', gridTemplateColumns: '1fr 1fr' },
          inputs: [
            {
              name: 'city',
              component: 'Input',
              value: address.city,
              placeholder: 'Digite aqui',
              type: 'text',
              title: 'Cidade',
              label: 'Cidade',
              required: true,
              validations: 'inputRequired',
            },
            {
              component: 'Select',
              title: 'Estado',
              label: 'Estado',
              value: address.state,
              name: 'state',
              required: true,
              placeholder: 'Selecione seu Estado',
              options: STATES.map((option) => ({
                label: option.name,
                value: option.uf,
              })),
            },
          ],
        },
        {
          name: 'complements',
          component: 'Input',
          value: address.complement,
          placeholder: 'Digite aqui',
          type: 'text',
          title: 'Complemento',
          label: 'Complemento',
          style: { marginBottom: '15px' },
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Salvar alterações',
          submittingText: 'Carregando...',
          color: true,
        },
      ],
    },
  ]

  const onSubmit = async (values: any): Promise<void> => {
    try {
      if (me !== null) {
        const requestData = {
          address: {
            zipcode: values.zipcode,
            street: values.street,
            number: values.number,
            neighborhood: values.neighborhood,
            city: values.city,
            state: values.state,
            complement: values.complements,
          },
        }

        await makeDoctorsEdit().update(me.id, requestData)
        history.goBack()
      } else {
        console.error('Variável "me" é nula.')
      }
    } catch (error) {
      console.error('Erro ao enviar formulário:', error)
    }
  }

  const imageUrl = user.document.find((doc) => doc.url.startsWith('images/'))?.url

  const name = `${user.firstName} ${user.lastName}`

  return (
    <EditAddress
      dataForm={dataForm}
      onSubmit={onSubmit}
      errorMessage={errorMessage}
      name={name}
      email={user.email}
      phone={user.phone}
      imageUrl={imageUrl}
    />
  )
}

export default MakeEditAddress
